import { isNullOrUndefined, extend } from '@syncfusion/ej2-base';
import { isEditable, createEditElement, parentsUntil, isCellHaveWidth } from '../base/util';
import { TextBox } from '@syncfusion/ej2-inputs';
import { EditCellBase } from './edit-cell-base';
/**
 * `DefaultEditCell` is used to handle default cell type editing.
 *
 * @hidden
 */
export class DefaultEditCell extends EditCellBase {
    create(args) {
        const attr = {
            type: 'text', value: !isNullOrUndefined(args.value) ? args.value : ''
        };
        const inputElement = createEditElement(this.parent, args.column, 'e-field e-input e-defaultcell', attr);
        if (args.column.textAlign) {
            inputElement.style.textAlign = args.column.textAlign;
        }
        return inputElement;
    }
    read(element) {
        if (element.type === 'hidden' && !isNullOrUndefined(element.ej2_instances[0]) &&
            !isNullOrUndefined(element.ej2_instances[0].textarea)) {
            return element.ej2_instances[0].value;
        }
        else {
            return element.value;
        }
    }
    write(args) {
        let mappingUid;
        const col = args.column;
        const isInline = this.parent.editSettings.mode !== 'Dialog';
        const props = {
            element: args.element, floatLabelType: this.parent.editSettings.mode !== 'Dialog' ? 'Never' : 'Always',
            enableRtl: this.parent.enableRtl,
            enabled: isEditable(args.column, args.requestType, args.element) &&
                isCellHaveWidth(parentsUntil(args.element, 'e-rowcell'), this.parent),
            placeholder: isInline ? '' : args.column.headerText,
            cssClass: this.parent.cssClass ? this.parent.cssClass : ''
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!isNullOrUndefined(col.edit) && !isNullOrUndefined(col.edit.params) && col.edit.params.multiline) {
            const cellValue = (col.valueAccessor(col.field, args.rowData, col));
            props['value'] = cellValue;
            mappingUid = props.element.getAttribute('data-mappinguid');
            props.element.removeAttribute('data-mappinguid');
            props.element.setAttribute('e-mappinguid', mappingUid);
        }
        this.obj = new TextBox(extend(props, col.edit.params));
        this.obj.appendTo(args.element);
        if (!isNullOrUndefined(mappingUid)) {
            this.obj.element.removeAttribute('e-mappinguid');
            this.obj.element.setAttribute('data-mappinguid', mappingUid);
        }
        if (this.parent.editSettings.mode === 'Batch') {
            this.obj.element.addEventListener('keydown', this.keyEventHandler);
        }
    }
    keyEventHandler(args) {
        if (args.key === 'Enter' || args.key === 'Tab') {
            const evt = new Event('change', { bubbles: false, cancelable: true });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.dispatchEvent(evt);
        }
    }
    destroy() {
        if (this.obj && !this.obj.isDestroyed) {
            this.obj.element.removeEventListener('keydown', this.keyEventHandler);
            this.obj.destroy();
            this.obj.element.remove();
        }
    }
}
